/** @format */

import {
  isSolePanel,
  baseShippingInfoProcessed,
  bundleProductDataInitialized,
  collectionsSet,
  customProductUpdated,
  dynamicTemplateChosen,
  dynamicTemplateNameSSRLoaded,
  eddInfoFetchErrored,
  eddInfoFetched,
  fetchSDDInfoError,
  fetchSDDInfoSuccess,
  inventoryFetchErrored,
  inventoryFetched,
  outOfStockTemplateInitialized,
  personalizationOptionsUpdated,
  primaryCategoryFetched,
  productHasBothEmptyAndNonEmptyPriceChecked,
  productStyleAndSkusInitialized,
  promotionsFetched,
  resolvedSkuShippingInfoProcessed,
  setFBTProducts,
  setTemplateProfile,
  skuResolutionActions,
  styliticsShopTheLookWidgetMounted,
} from './product-selection.actions';
import { createReducer, on } from '@ngrx/store';

import { DynamicProductTemplate } from '@pdp/data-access/enums';
import { ProductSelectionCoreState } from '@pdp/data-access/interfaces';

// 02 Define the initial state
export const initialProductSelectionState: ProductSelectionCoreState = {
  productStyle: {},
  bundleData: {},
  bundleProductsData: [],
  collections: [],
  productSkus: [],
  resolvedSku: null,
  resolvedSkuSDDInventory: null,
  sddError: null, // Store error state for SDD
  ecommInventory: null,
  bopisInventory: null,
  primaryCategory: null,
  hasBothEmptyAndNonEmptyPrice: false,
  isSolePanel: false,
  shippingInfo: {},
  promotionData: null,
  eddInfo: null,
  eddError: null, // Store error state for EDD
  customProductData: null,
  loadingProductImages: false,
  selectedPersonalizationOptions: {},
  FBTProducts: [],
  styliticsWidgetShown: false,
  productHasColorWithStylitics: false,
  templateName: DynamicProductTemplate.NOT_FOUND_DEFAULT,
  templateProfile: null,
};

export const productSelectionReducers = createReducer(
  // Supply the initial state
  initialProductSelectionState,
  on(dynamicTemplateChosen, dynamicTemplateNameSSRLoaded, (state, { templateName }) => ({
    ...state,
    templateName,
  })),
  on(isSolePanel, (state, { isSolePanel }) => ({
    ...state,
    isSolePanel,
  })),
  on(setTemplateProfile, (state, { templateProfile }) => ({
    ...state,
    templateProfile,
  })),
  on(productStyleAndSkusInitialized, (state, { productStyle, productSkus }) => ({
    ...state,
    productStyle,
    productSkus,
  })),
  on(bundleProductDataInitialized, (state, { bundleData, bundleProductsData }) => ({
    ...state,
    bundleData,
    bundleProductsData,
  })),
  on(collectionsSet, (state, { collections }) => ({
    ...state,
    collections,
  })),
  on(...skuResolutionActions, (state, { resolvedSku }) => ({
    ...state,
    resolvedSku,
    eddInfo: undefined,
  })),
  on(fetchSDDInfoSuccess, (state, { sdd }) => ({
    ...state,
    resolvedSkuSDDInventory: sdd,
    sddError: null,
  })),
  on(fetchSDDInfoError, (state, { error }) => ({
    ...state,
    resolvedSkuSDDInventory: null,
    sddError: error,
  })),
  on(eddInfoFetched, (state, { eddInfo }) => ({
    ...state,
    eddInfo,
    eddError: null,
  })),
  on(eddInfoFetchErrored, (state, { error }) => ({
    ...state,
    eddInfo: null,
    eddError: error,
  })),
  on(inventoryFetched, (state, { ecommInventory, bopisInventory }) => ({
    ...state,
    ecommInventory,
    bopisInventory,
  })),
  on(inventoryFetchErrored, (state) => ({
    ...state,
    ecommInventory: [],
    bopisInventory: [],
  })),
  on(primaryCategoryFetched, (state, { primaryCategory }) => ({
    ...state,
    primaryCategory,
  })),
  on(productHasBothEmptyAndNonEmptyPriceChecked, (state, { hasBothEmptyAndNonEmptyPrice }) => ({
    ...state,
    hasBothEmptyAndNonEmptyPrice,
  })),
  on(baseShippingInfoProcessed, resolvedSkuShippingInfoProcessed, (state, { shippingInfo }) => ({
    ...state,
    shippingInfo,
  })),
  on(promotionsFetched, (state, { promotionData }) => ({
    ...state,
    promotionData,
  })),
  on(customProductUpdated, (state, { customProductData }) => ({
    ...state,
    customProductData,
  })),
  on(personalizationOptionsUpdated, (state, { selectedPersonalizationOptions }) => ({
    ...state,
    selectedPersonalizationOptions,
  })),
  on(setFBTProducts, (state, { FBTProducts }) => ({
    ...state,
    FBTProducts,
  })),
  on(styliticsShopTheLookWidgetMounted, (state, { styliticsWidgetShown }) => ({
    ...state,
    styliticsWidgetShown,
    productHasColorWithStylitics: state.productHasColorWithStylitics || styliticsWidgetShown,
  })),
  on(outOfStockTemplateInitialized, (state) => ({
    ...state,
    ecommInventory: [],
    bopisInventory: [],
    promotionData: {},
  })),
);
